import {SvgIconProps} from "@mui/material";
import React, {ReactNode} from "react";
import AbstractIcon from "../AbstractIcon";


class ActiveResourceFallback extends AbstractIcon {

    public renderDraw(props: SvgIconProps): ReactNode {
        return (
            <g>
                <path d="m 4,5 v 5 H 5 V 5 Z"/>
                <path d="M 6,6 V 9 H 7 V 6 Z"/>
                <path d="m 8,3 v 9 H 9 V 3 Z"/>
                <path d="m 10,4 v 7 h 1 V 4 Z"/>
                <path d="m 12,2 v 11 h 1 V 2 Z"/>
                <path d="m 14,5 v 5 h 1 V 5 Z"/>
                <path d="m 16,6 v 3 h 1 V 6 Z"/>
                <path d="m 18,4 v 7 h 1 V 4 Z"/>
                <path d="M 2,6 V 9 H 3 V 6 Z"/>
                <path d="m 20,6 v 3 h 1 V 6 Z"/>
                <path d="m 22,7 v 1 h 1 V 7 Z"/>
                <path d="M 14.019531,11.990234 C 14.008501,11.990234 14,14.244649 14,17 c 0,4.177855 0.008,5.006664 0.05078,4.990234 0.02823,-0.01083 0.712377,-0.402474 1.519531,-0.86914 0.807156,-0.466666 1.973777,-1.140974 2.59375,-1.498047 1.162922,-0.669784 1.395685,-0.802726 1.949219,-1.125 0.588529,-0.342648 1.042186,-0.605003 1.806641,-1.044922 0.415068,-0.238857 0.753906,-0.444881 0.753906,-0.457031 0,-0.01214 -0.175211,-0.122263 -0.390625,-0.246094 C 22.067789,16.626169 21.736019,16.434478 21.546875,16.324219 21.08662,16.055922 19.53435,15.158005 18.242188,14.414062 17.12801,13.772596 16.647748,13.495628 15.042969,12.568359 14.491806,12.249888 14.030541,11.990234 14.019531,11.990234 Z M 15,15 h 1 2 v 1 h -2 v 1 h 1 v 1 h -1 v 2 h -1 v -2 -1 -1 z" />
            </g>
        );
    }

}


export default ActiveResourceFallback;